<div
    class="bg-on-primary rounded-xl"
    [class]="isSourceTheme() ? 'p-1' : 'p-2'">
    <div class="flex w-full my-3 pl-2">
        <div
            class="flex-1 truncate text-lg font-normal leading-tight"
            [class]="!isActive() && isDataLayerSource() ? 'text-custom-dark-grey' : 'text-black'">
            {{ sources()[0].name }}
            @if (depositName()) {
                <span class="italic font-normal text-sm"> ({{ depositName() }})</span>
            }
        </div>

        <div class="flex items-center gap-3 shrink-0 pr-4">
            @if (layerEditConfig()?.canGeographicEdit && canBeEdited()) {
                <div class="w-5 h-5 text-base items-center justify-center pt-1">
                    <app-geographic-edit-button
                        [customTooltip]="noGeomEditionReason()"
                        [hasPermission]="!!layerEditConfig()?.canGeographicEdit"
                        [isActive]="isGeographicEditActive()"
                        [isAvailable]="isGeomEditionAvailable()"
                        [isEditable]="isLayerEditable()"
                        [layerEditConfig]="layerEditConfig()"
                        (actionClick)="editGeometry()" />
                </div>
            }

            @if (layerEditConfig()?.canAddEntity && canBeEdited()) {
                <div class="w-5 h-5 text-base items-center justify-center">
                    <app-add-entity-button
                        [customTooltipKey]="
                            allLayerHasSameBookmarkedColumn() ? undefined : 'groupedLayerDontHaveSameAttributes'
                        "
                        [hasPermission]="!!layerEditConfig()?.canAddEntity"
                        [isActive]="isAddEntityActive() && allLayerHasSameBookmarkedColumn()"
                        [isAvailable]="allLayerHasSameBookmarkedColumn() && !contentLayoutService.isDataTableView()"
                        [isEditable]="isLayerEditable()"
                        [layerEditConfig]="layerEditConfig()"
                        (actionClick)="addEntity()" />
                </div>
            }

            <div class="w-5 h-5 text-base items-center justify-center">
                <app-visibility-button
                    [canToggle]="canToggleVisibility()"
                    [customToolTip]="isAnEditLayer() ? 'cannotHideEditLayer' : undefined"
                    [isGroup]="false"
                    [visibilityButtonState]="visibilityButtonState()"
                    (visibilityToggle)="changeSourceVisibility($event)" />
            </div>

            @if (hasTabView()) {
                <fa-icon
                    class="w-5 h-5 text-base hover:text-custom-blue cursor-pointer text-black"
                    [icon]="['far', 'table-list']"
                    [matTooltip]="'displayTabularView' | transloco"
                    (click)="openTabView.emit($event)" />
            }
        </div>
    </div>
</div>
